import createHttpAuthLib from '../../../commons/src/libs/http-json-auth'

export default createHttpAuthLib(false)
